export const HELP_CENTER_APPLICATION_NAME = 'help-center-page';
export const SEARCH_BAR_FLYOUT_APPLICATION_NAME = 'SearchBarFlyout';
